import { useQuery } from 'react-query';
import { AXIOS, axios, axios2 } from '@/lib/axiosData';
import { ExtractFnReturnType, QueryConfig } from '@/lib/react-query';
import { Listing } from '@/types';

export const newLandingListing = ({
  type,
  filter_data,
  search_data,
  sub_category,
  bedrooms,
  bathrooms,
  latitude,
  longitude,
  subscription_tyre,
  min_price,
  max_price,
  dateSort,
  priceSort,
  country,
  countries,
  date,
  page,
}: {
  filter_data: boolean;
  bedrooms?: string;
  bathrooms?: string;
  type: any;
  search_data: string;
  sub_category: string;
  dateSort?: string;
  priceSort?: string;
  latitude: string;
  longitude: string;
  subscription_tyre: string;
  min_price: string;
  max_price: string;
  countries: string;
  page: number;
  date?: string;
  country: string;
}): Promise<Listing[]> => {
  return AXIOS.get(`/customer-api/home-page-data-listing`, {
    params: {
      filter_data,
      type,
      search_data,
      sub_category,
      bathrooms,
      bedrooms,
      latitude,
      longitude,
      subscription_tyre,
      min_price,
      max_price,
      price_filter: priceSort,
      published_date: dateSort,
      page,
      country,
      countries,
      page_size: 8,
      date_filter: date,
    },
  });
};

type QueryFnType = typeof newLandingListing;

type UseNewListingOptions = {
  config?: QueryConfig<QueryFnType>;
  bedrooms?: string;
  bathrooms?: string;
  type: any;
  filter_data: boolean;
  search_data: string;
  sub_category: string;
  latitude: string;
  longitude: string;
  subscription_tyre: string;
  min_price: string;
  max_price: string;
  page: number;
  country?: string;
  countries?: string;
  date?: string;
  dateSort?: string;
  priceSort?: string;
};

export const useNewLandingListing = ({
  config,
  type,
  filter_data,
  dateSort,
  priceSort,
  country,
  bedrooms,
  date,
  bathrooms,
  countries,
  search_data,
  sub_category,
  latitude,
  longitude,
  subscription_tyre,
  min_price,
  max_price,
  page,
}: UseNewListingOptions) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: [
      'listing-landing-page',
      {
        type,
        filter_data,
        search_data,
        sub_category,
        bedrooms,
        bathrooms,
        latitude,
        longitude,
        dateSort,
        priceSort,
        countries,
        country,
        date,
        subscription_tyre,
        page,
      },
    ],
    queryFn: () =>
      newLandingListing({
        filter_data,
        type,
        search_data,
        sub_category,
        bedrooms,
        bathrooms,
        date,
        dateSort,
        priceSort,
        latitude,
        country,
        countries,
        longitude,
        subscription_tyre,
        min_price,
        max_price,
        page,
      }),
  });
};
